import FormatCurrency from 'components/Common/FormatCurrency'
import Caption from 'LuxKit/Typography/Caption'
import React, { ComponentProps } from 'react'

type InheritedFormatCurrencyProps = Pick<ComponentProps<typeof FormatCurrency>, 'signDisplay'>

interface Props extends InheritedFormatCurrencyProps {
  nonMemberPrice: number
  className?: string
}

/**
 * Displays price for non-members with a proper caption.
 */
function PriceRowLuxPlusNonMemberPrice(props: Props) {
  const {
    nonMemberPrice,
    signDisplay,
    className,
  } = props

  return <Caption
    variant="medium"
    colour="neutral-two"
    className={className}
  >
    Non-member
    {' '}
    <b><FormatCurrency signDisplay={signDisplay} value={nonMemberPrice} format="roundedDollar" /></b>
  </Caption>
}

export default PriceRowLuxPlusNonMemberPrice
